
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { PlusCircle, ExternalLink } from 'lucide-react';
import { Subscription } from '@/hooks/useCurrentSubscription';

interface FreemiumSubscriptionProps {
  subscription: Subscription | null;
}

const FreemiumSubscription: React.FC<FreemiumSubscriptionProps> = ({ subscription }) => {
  const handleVisitWebsite = () => {
    window.open('https://zan.estate/', '_blank');
  };

  return (
    <Card className="mt-6">
      <CardHeader>
        <CardTitle className="text-xl">Compte Freemium</CardTitle>
        <CardDescription>
          Vous utilisez actuellement le plan gratuit avec des fonctionnalités limitées.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="py-6 text-center space-y-4">
          <div className="bg-muted p-8 rounded-lg flex justify-center">
            <PlusCircle className="h-20 w-20 text-muted-foreground" />
          </div>
          <p className="text-muted-foreground">
            Profitez de fonctionnalités avancées en choisissant un plan premium adapté à vos besoins:
          </p>
          <ul className="text-left ml-6 text-sm space-y-2 text-muted-foreground list-disc">
            <li>Accès à toutes les fonctionnalités de simulation financière</li>
            <li>Gestion d'équipe avancée</li>
            <li>Connexion à des APIs et systèmes externes</li>
            <li>Rapports détaillés et analyses</li>
            <li>Support prioritaire</li>
          </ul>
        </div>
      </CardContent>
      <CardFooter className="flex flex-col space-y-2 sm:flex-row sm:space-y-0 sm:space-x-2">
        <Button variant="outline" onClick={handleVisitWebsite} className="w-full sm:w-auto flex items-center gap-1">
          <ExternalLink className="h-4 w-4" /> Découvrir les avantages premium
        </Button>
        <Button size="lg" className="w-full sm:w-auto" asChild>
          <Link to="/subscription-change/new">
            Voir les plans disponibles
          </Link>
        </Button>
      </CardFooter>
    </Card>
  );
};

export default FreemiumSubscription;
